export const PAGE_NAME = 'getStatusPage';
export const SUBMIT_FORM = `${PAGE_NAME}/SUBMIT_FORM`;

export const FORM_VALIDATION_RULES = {
  lastName: { presence: { allowEmpty: false, message: "^Last Name can't be blank" } },
  orderId: { presence: { allowEmpty: false, message: "^Order Number can't be blank" } },
};
